var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreenRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#08AA15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4252 5.52033C11.6349 5.70004 11.6592 6.01569 11.4795 6.22535C10.4183 7.46119 9.34198 8.69705 8.15036 9.80923C7.82724 10.1108 7.37922 10.6 6.89983 10.6C6.55682 10.6 6.25393 10.3802 6.00611 10.1648C5.4223 9.65709 4.93274 9.01743 4.49039 8.38694C4.33203 8.16071 4.38687 7.8487 4.6131 7.69034C4.8393 7.532 5.15103 7.58699 5.3094 7.81317L5.31 7.81402C5.70609 8.3768 6.14025 8.9562 6.66229 9.41015C6.74959 9.48606 6.82157 9.53915 6.87679 9.57233C7.09115 9.43197 7.28145 9.25233 7.46804 9.07818C8.63268 7.99118 9.68191 6.78148 10.7201 5.57469C10.8998 5.36503 11.2156 5.34062 11.4252 5.52033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenRounded);
export default __webpack_public_path__ + "static/media/checkGreenRounded.b0bcc8b6039d8d74d80be16664933bde.svg";
export { ForwardRef as ReactComponent };